import React, {  } from "react";
import { connect } from "react-redux";
import LinearProgress from "@mui/material/LinearProgress";
import { GlobalRoutes,AuthRequiredPaths,LANDING_PATH } from "./Routes";
import AppRouter from "./AppRouter";
import {postLoginPath } from "./constants";
import { loginActions } from "@redux/actionCreators/UserActions";


class GlobalRouter extends React.Component {
  constructor(props) {
    super(props);
    this.onRouteChange = this.onRouteChange.bind(this);
  }
  componentDidMount() {
    this.props.initApp();
    this.path = location.path;
  }
  onRouteChange(path,isLoggedIn){
    path!=this.path && this.props.onRouteChange(path,this.path,isLoggedIn);
    this.path = path;
  }
  render() {
    if (!this.props.isInitialized) {
      return <LinearProgress />;
    }
    return (
      <AppRouter appRoutes={GlobalRoutes} onRouteChange={this.onRouteChange} landingPath={LANDING_PATH} postLoginPath={postLoginPath}/>
    );
  }
}

const mapStateToProps = state => ({
  isInitialized: state.userReducer.isInitialized,
  isLoggedIn: state.userReducer.isLoggedIn,
});

const mapDispatchToProps = dispatch => ({
  initApp: () =>{
    loginActions.IHP_CHANNEL.onmessage = ({event,uid,data})=>{
      const {appContext,CHANNEL_EVENTS,signout,refreshSession,expirySession,updateUserSelectedClinicId} = loginActions;
      //console.log('event',event,uid,appContext.uid);
      switch(event){
        case CHANNEL_EVENTS.SIGN_IN: !appContext.user && window.location.reload();break;
        case CHANNEL_EVENTS.SIGN_OUT: appContext.user && dispatch(signout);break;
        case CHANNEL_EVENTS.CLINIC_SWITCH: appContext.user && (location.pathname = GlobalRoutes.LANDING.path) ;break;
        case CHANNEL_EVENTS.SESSION_REFRESHED:appContext.user && dispatch(refreshSession(data.lat));break;
        case CHANNEL_EVENTS.SESSION_EXPIRED:appContext.user && dispatch(expirySession);break;
      }
    }

    dispatch(loginActions.initializeApplication());
  },
  onRouteChange:(path,oldPath,isLoggedIn)=>{
    console.log('new path',path,oldPath,isLoggedIn);
    if(AuthRequiredPaths.includes(path)){
      localStorage.setItem(_app.u.luid+"lpath",location.pathname);
      //dispatch(errorActions.resetCustomAuthenticationErrorCode());
    } 
  }
});
export const landingPath = LANDING_PATH;
export default connect(mapStateToProps, mapDispatchToProps)(GlobalRouter);
